import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "../../hooks/useForm";
import backArrowIcon from "../../assets/img/back-arrow.png";
import "../../assets/css/common.css";
import { useAuth } from "../../routers/AuthProvider";
import AsyncSelect from "react-select/async";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import PromotionProductTable from "../../components/PromotionProductTable";
import { Toast } from "../../components/ToastComponent";

export default function CreatePromotion() {
  const backPath = `/promotion/list`;
  const {
    handleInputChange,
    formData,
    submitForm,
    setError,
    error,
    setFormData,
  } = useForm();
  const navigate = useNavigate();
  const { user, setLoading } = useAuth();

  const [selectedOption, setSelectedOption] = useState("");
  const [promotionType, setPromotionType] = useState();

  const handleOptionChange = (event) => {
    setFormData({});
    setSelectedOption(event.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      type: selectedOption,
      data: {
        ...formData,
        promotion_type: promotionType,
        status: "ACTIVE",
      },
    };
    if (selectedOption === "CROSS_PRODUCT") {
      const crossable_products = buyProducts.map((product) => ({
        product_id: product.product_id,
        barcode: product.barcode,
        quantity: product.quantity,
      }));

      let promo_products = getProducts.map((product) => ({
        product_id: product.product_id,
        barcode: product.barcode,
        quantity: product.quantity,
      }));

      data.data.crossable_products = crossable_products;
      data.data.promo_products = promo_products;
    }

    if (selectedOption === "PERCENT") {
      data.data.product_id = percentProduct.product_id;
      data.data.barcode = percentProduct.barcode;
    }

    if (selectedOption === "BOGO") {
      // Attach selected product
      data.data.product_id = bogoProduct.product_id;
      data.data.barcode = bogoProduct.barcode;
    }
    submitForm(
      "POST",
      "/promotion",
      data,
      () => {
        //     navigate(backPath)
        // });
        navigate(backPath);
      },
      "Successfully Created"
    );
  };

  useEffect(() => {
    if (error) {
      Toast.fire({
        title: error,
        icon: "error",
      });
    }
  }, [error]);

  useEffect(() => {
    switch (selectedOption) {
      case "AMOUNT":
        setPromotionType("By Total");
        break;
      case "PERCENT":
        setPromotionType("By Percent");
        break;
      case "BOGO":
        setPromotionType("By BOGO");
        break;
      case "CROSS_PRODUCT":
        setPromotionType("By Cross Product");
        break;
      default:
        break;
    }
  }, [selectedOption]);

  const [buyProducts, setBuyProducts] = useState([]);
  const [getProducts, setGetProducts] = useState([]);
  const [percentProduct, setPercentProduct] = useState();
  const [bogoProduct, setBogoProduct] = useState();

  const [errorPercentMessage, setErrorPercentMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorPointMessage, setErrorPointMessage] = useState("");

  const [errorBuyMessage, setErrorBuyMessage] = useState("");
  const [errorGetMessage, setErrorGetMessage] = useState("");
  const [promotionAmount, setPromotionAmount] = useState();
  const [minPoint, setMinPoint] = useState();
  const [productOptions, setProductOptions] = useState([]);

  useEffect(() => {
    axios
      .get(API_URL + "/product/no-price", {
        withCredentials: true,
      })
      .then((response) => {
        setProductOptions(response.data?.data || []);
      });
  }, []);

  const loadOptions = (inputValue) => {
    const normalized = inputValue.toLowerCase();
    return Promise.resolve(
      productOptions.filter((option) =>
        option.product_name.toLowerCase().includes(normalized)
      )
    );
  };

  return (
    <div className="sub-page-layout-1">
      <Link className="back-to-page" to={backPath}>
        <img src={backArrowIcon} />
        Back
      </Link>
      <div className="container" style={{ height: "auto" }}>
        <h1 className="sub-page-title">Create New Promotion</h1>
        <div className="form-container">
          <form
            onSubmit={onSubmit}
            className="form flex flex-col justify-between w-full"
          >
            <h2 className="sub-title mb-8">Promotion Information</h2>
            <div className="grid grid-cols-2 gap-9">
              <div className="grow">
                <label className="x-label input-required">Promotion Type</label>
                <div className="dd-container">
                  <select
                    type="text"
                    required
                    name="promotion_type"
                    value={selectedOption}
                    onChange={handleOptionChange}
                    className="x-input dropdown"
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    <option value="AMOUNT">Promotion By Total Amount</option>
                    <option value="BOGO">Promotion By BOGO</option>
                    <option value="PERCENT">Promotion By Percents</option>
                    <option value="CROSS_PRODUCT">
                      Promotion By Cross Products
                    </option>
                  </select>
                </div>
              </div>
              <div className="grow"></div>
              {selectedOption === "AMOUNT" && (
                <>
                  <div className="grow">
                    <label className="x-label input-required">
                      Promotion Amount
                    </label>
                    <input
                      type="text"
                      required
                      min={0}
                      name="promotion_amount"
                      //onChange={handleInputChange}
                      pattern="[0-9]{1,}"
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        setPromotionAmount(numericValue);

                        const numeric = parseInt(numericValue, 10);

                        if (!numericValue) {
                          setErrorMessage("Please enter a number.");
                        } else if (isNaN(numeric) || numeric < 1) {
                          setErrorMessage("Number must be 1 or greater.");
                        } else {
                          setErrorMessage(""); // Clear message when valid
                        }
                        handleInputChange({
                          target: {
                            name: "promotion_amount",
                            value: numericValue,
                          },
                        });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                      className="x-input"
                    />
                    {errorMessage && (
                      <div className="text-red-500 text-sm mt-1">
                        {errorMessage}
                      </div>
                    )}
                  </div>
                  <div className="grow"></div>
                  <div className="grow">
                    <label className="x-label input-required">
                      Minimum Total Amount
                    </label>
                    <input
                      type="text"
                      required
                      min={0}
                      name="minimum_total_amount"
                      //onChange={handleInputChange}
                      pattern="[0-9]{1,}"
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        setMinPoint(numericValue);

                        const numeric = parseInt(numericValue, 10);

                        if (!numericValue) {
                          setErrorPointMessage("Please enter a number.");
                        } else if (isNaN(numeric) || numeric < 1) {
                          setErrorPointMessage("Number must be 1 or greater.");
                        } else {
                          setErrorPointMessage(""); // Clear message when valid
                        }
                        handleInputChange({
                          target: {
                            name: "minimum_total_amount",
                            value: numericValue,
                          },
                        });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                      className="x-input"
                    />
                    {errorPointMessage && (
                      <div className="text-red-500 text-sm mt-1">
                        {errorPointMessage}
                      </div>
                    )}
                  </div>
                  <div className="grow">
                    <label className="x-label input-required">
                      Currency Type
                    </label>
                    <div className="dd-container">
                      <select
                        type="text"
                        required
                        name="currency_type"
                        onChange={handleInputChange}
                        defaultValue=""
                        className="x-input dropdown"
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="MMK">MMK</option>
                        <option value="THB">THB</option>
                      </select>
                    </div>
                  </div>
                </>
              )}
              {selectedOption === "BOGO" && (
                <>
                  <div className="grow">
                    <label className="x-label input-required">
                      Product Name
                    </label>
                    <AsyncSelect
                      required
                      defaultOptions={productOptions}
                      cacheOptions
                      loadOptions={loadOptions}
                      isSearchable={true}
                      getOptionLabel={(option) => option.product_name}
                      getOptionValue={(option) => option.product_id}
                      onChange={(option) => setBogoProduct(option)}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: "#1b1b1b66",
                          minHeight: "50px",
                        }),
                      }}
                    />
                  </div>
                  <div className="grow"></div>
                </>
              )}
              {selectedOption === "PERCENT" && (
                <>
                  <div className="grow">
                    <label className="x-label input-required">Percent</label>
                    <input
                      type="text"
                      min={1}
                      max={100}
                      required
                      name="percent_amount"
                      //onChange={handleInputChange}
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        const value = parseInt(numericValue, 10);

                        if (value < 1 || value > 100 || isNaN(value)) {
                          setErrorPercentMessage(
                            "Please enter a value between 1 and 100"
                          );
                        } else {
                          setErrorPercentMessage(""); // Clear error
                        }

                        handleInputChange(e);
                      }}
                      className="x-input"
                    />
                    {errorPercentMessage && (
                      <div className="text-red-500 text-sm mt-1">
                        {errorPercentMessage}
                      </div>
                    )}
                  </div>
                  <div className="grow">
                    <label className="x-label input-required">
                      Product Name
                    </label>
                    <AsyncSelect
                      required
                      defaultOptions={productOptions}
                      cacheOptions
                      loadOptions={loadOptions}
                      isSearchable={true}
                      getOptionLabel={(option) => option.product_name}
                      getOptionValue={(option) => option.product_id}
                      onChange={(option) => setPercentProduct(option)}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: "#1b1b1b66",
                          minHeight: "50px",
                        }),
                      }}
                    />
                  </div>
                </>
              )}

              {selectedOption === "CROSS_PRODUCT" && (
                <>
                  <div className="grow">
                    <label className="x-label input-required">
                      Buy Product
                    </label>
                    <AsyncSelect
                      required
                      type="text"
                      pattern="[0-9]{1,}"
                      min={1}
                      defaultOptions={productOptions}
                      cacheOptions
                      loadOptions={loadOptions}
                      isSearchable={true}
                      isMulti={true}
                      getOptionLabel={(option) => option.product_name}
                      getOptionValue={(option) => option.product_id}
                      onChange={(option) => {
                        const newObj = option.map((item) => {
                          // const quantity = item.quantity ? item.quantity : 1
                          let quantityValue = item.quantity ? item.quantity : 1;
                          let quantityStr = String(quantityValue).replace(
                            /[^0-9]/g,
                            ""
                          );
                          let quantity = parseInt(quantityStr, 10);

                          if (quantity < 1) {
                            setErrorBuyMessage(
                              "Quantity must be greater than or equal 1."
                            );
                          } else {
                            setErrorBuyMessage("");
                          }
                          return { ...item, quantity };
                        });
                        setBuyProducts(newObj);
                      }}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: "#1b1b1b66",
                          minHeight: "50px",
                        }),
                      }}
                    />
                    {errorBuyMessage && (
                      <div className="text-red-500 text-sm mt-1">
                        {errorBuyMessage}
                      </div>
                    )}
                  </div>
                  <div className="grow">
                    <label className="x-label input-required">
                      Get Product
                    </label>
                    <AsyncSelect
                      required
                      type="text"
                      pattern="[0-9]{1,}"
                      defaultOptions={productOptions}
                      cacheOptions
                      loadOptions={loadOptions}
                      isSearchable={true}
                      isMulti={true}
                      min={1}
                      getOptionLabel={(option) => option.product_name}
                      getOptionValue={(option) => option.product_id}
                      onChange={(option) => {
                        const newObj = option.map((item) => {
                          let quantityValue = item.quantity ? item.quantity : 1;
                          let quantityStr = String(quantityValue).replace(
                            /[^0-9]/g,
                            ""
                          );
                          let quantity = parseInt(quantityStr, 10);

                          if (quantity < 1) {
                            setErrorGetMessage(
                              "Quantity must be greater than or equal 1."
                            );
                          } else {
                            setErrorGetMessage("");
                          }

                          return { ...item, quantity };
                        });
                        setGetProducts(newObj);
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: "#1b1b1b66",
                          minHeight: "50px",
                        }),
                      }}
                    />
                    {errorGetMessage && (
                      <div className="text-red-500 text-sm mt-1">
                        {errorGetMessage}
                      </div>
                    )}
                  </div>
                </>
              )}

              {selectedOption && (
                <>
                  <div className="grow">
                    <label className="x-label input-required">Start Date</label>
                    <input
                      type="date"
                      required
                      name="start_date"
                      onChange={handleInputChange}
                      className="x-input"
                    />
                  </div>
                  <div className="grow">
                    <label className="x-label input-required">End Date</label>
                    <input
                      type="date"
                      required
                      name="end_date"
                      autoComplete="false"
                      onChange={handleInputChange}
                      className="x-input"
                    />
                  </div>
                </>
              )}
            </div>
            {selectedOption === "CROSS_PRODUCT" && (
              <>
                <div className="pt-9">
                  <PromotionProductTable
                    products={buyProducts}
                    setProducts={setBuyProducts}
                    title="Buy Product"
                  />
                </div>
                <div className="pt-9">
                  <PromotionProductTable
                    products={getProducts}
                    setProducts={setGetProducts}
                    title="Get Product"
                  />
                </div>
              </>
            )}
            <div className="form-btn-group">
              <div className="flex justify-end gap-5 mt-5">
                <Link to={backPath} className="white-btn">
                  Cancel
                </Link>
                <button className="gold-btn">Create</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
